<template lang="pug">
.generic-wrapper
  .container
    h1.title Statistik
    .sub-headline Hier können Sie alle Statistiken einsehen.

    MenuItems
      MenuItem(name="Eigentümerstatistik" description="Hier können Sie alle Eigentümerstatistiken ansehen." @click="$router.push({name: 'StatisticsOwners'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
            path(d='M22 12A10 10 0 0 0 12 2v10z')

      MenuItem(name="Buchungsübersicht" description="Hier können Sie alle Mietobjektstatistiken ansehen." @click="$router.push({name: 'StatisticsRentObjects'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
            path(d='M22 12A10 10 0 0 0 12 2v10z')

      MenuItem(v-if="me.firstName === 'Alex'" name="Vermietungsübersicht" description="Hier können Sie alle Einzelheiten Ihrer Vermietungstätigkeit einsehen." @click="$router.push({name: 'StatisticsItemSummary'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
            path(d='M22 12A10 10 0 0 0 12 2v10z')

      MenuItem(v-if="me.firstName === 'Alex'" name="Kundenanalyse" description="Wer sind eigentlich Ihre Kunden? Hier sehen Sie es." @click="$router.push({name: 'StatisticsCustomerAnalysis'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
            path(d='M22 12A10 10 0 0 0 12 2v10z')

      MenuItem(v-if="me.firstName === 'Alex'" name="Gesamteinnahmen" description="Alle Zahlen auf einen Blick für die Geschäftsführung." @click="$router.push({name: 'StatisticsRevenueSummary'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
            path(d='M22 12A10 10 0 0 0 12 2v10z')

      MenuItem(v-if="me.firstName === 'Alex'" name="Auslastung" description="Erkennen Sie die Auslastung auf einen Blick pro Jahr" @click="$router.push({name: 'UtilizationTable'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
            path(d='M22 12A10 10 0 0 0 12 2v10z')
</template>

<script>
import MenuItem from "@/components/atoms/MenuItem.vue";
import MenuItems from "@/components/molecules/MenuItems.vue";

export default {
  components: {
    MenuItem,
    MenuItems
  },
  async beforeMount() {
    // When logged in we try to get the user information
    await this.$store.dispatch("me/getMe");
  },
  computed: {
    me() {
      return this.$store.state.me.me
    }
  },
};
</script>